<template>
    <div class="login-form mb-4">
        <div
            v-if="error && error.error_message"
            class="alert alert-danger"
            role="alert"
        >
            {{ error.error_message }}
        </div>
        <div v-if="deviceToken">
            <div class="mb-2">
                <label
                    class="form-label"
                    for="usernameInput"
                >Gebruikersnaam</label>
                <input
                    class="form-control"
                    id="usernameInput"
                    type="email"
                    name="username"
                    v-model="username"
                    autofocus
                >
            </div>
            <div class="mb-4">
                <label
                    class="form-label"
                    for="passwordInput"
                >Wachtwoord</label>
                <div class="input-group">
                    <input
                        class="form-control"
                        id="passwordInput"
                        name="password"
                        :type="showPassword ? 'text' : 'password'"
                        v-model="password"
                        v-on:keyup.enter="login"
                    />
                    <button
                        class="btn"
                        id="passwordBtn"
                        type="button"
                        @click="togglePassword"
                    >
                        <i :class="showPassword ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"></i>
                    </button>
                </div>
            </div>
            <div class="d-grid">
                <button
                    v-if="isLoading === false"
                    class="btn btn-info"
                    v-on:click="login"
                >Inloggen</button>
                <button
                    v-else
                    class="btn btn-info"
                    disabled
                >
                    <icon name="loading"></icon>
                </button>
            </div>
        </div>
        <div v-else>
            <p class="text-center fw-bold pt-4 mb-0">
                Een ogenblik geduld...
            </p>
        </div>
    </div>
</template>

<script>
import Icon from "@/components/Icon.vue";

export default {
    name: "login-form",
    components: {Icon},
    data() {
        return {
            isLoading: false,
            error: null,
            username: null,
            password: null,
            showPassword: false
        };
    },
    created() {
        if (!this.deviceToken) {
            this.isLoading = true
            this.$request.get('/authentication/device-token')
                .then(response => {
                    this.isLoading = false
                    if (response.device_token) {
                        this.$store.commit('SET_DEVICE_TOKEN', response.device_token)
                    } else {
                        this.error = {
                            error_message: 'Kon geen verbinding maken met de API.<br><a href="' + window.location.href + '">Probeer opnieuw</a>'
                        }
                    }
                }).catch(() => {
                this.isLoading = false
            });
        }
    },
    methods: {
        login() {
            this.error = null
            this.isLoading = true
            this.$request.post('/authentication/login', {
                device_token: this.deviceToken,
                username: this.username,
                password: this.password,
                resource: 'Employees\\Model\\Employee'
            })
                .then((response) => {
                    this.isLoading = false
                    if (response && response.session_token) {
                        this.$store.commit('SET_SESSION', {session_token: response.session_token})
                        this.$emit('login', response)
                    } else if (response && response.mfa_enabled && response.mfa_enabled === true) {
                        this.error = {
                            error_message: 'Voor dit account is tweefactorauthenticatie geactiveerd. Het is nog niet mogelijk om met tweefactorauthenticatie in te loggen op de Groepsapp. Log in op Kidsadmin en klik via het gebruikersicoontje rechts bovenin op "Inloggen op groepsapp".'
                        }
                    } else if (response.error) {
                        this.error = response.error
                    }
                })
                .catch((error) => {
                    this.isLoading = false
                    if (error && error.error) {
                        this.error = error.error
                    } else {
                        this.error = {
                            error_message:
                                "Er ging iets mis, controleer de verbinding en probeer opnieuw",
                        };
                    }
                });
        },
        togglePassword() {
            this.showPassword = !this.showPassword;
        },
    },
};
</script>

<style scoped>
</style>
